import { createSelector } from 'reselect';
import { MOET_CONSTANTS } from 'moet-core';

import { getMerchantStatus, getMerchantStatusValue, hasHadTransaction } from './common';

const { ONBOARDING_STATUS_VALUES_V2, STEP_STATUS } = MOET_CONSTANTS;

export const getMerchantTransactionStatus = createSelector(
  getMerchantStatusValue,
  onboardingStatusValue => {
    if (onboardingStatusValue >= ONBOARDING_STATUS_VALUES_V2.TRANSACTIONS_ENABLED) {
      return STEP_STATUS.DONE;
    }

    if (onboardingStatusValue > ONBOARDING_STATUS_VALUES_V2.TRANSACTION_DETAILS_STARTED) {
      return STEP_STATUS.PENDING;
    }

    return STEP_STATUS.NOT_STARTED;
  },
);

export const getMerchantPayoutStatus = createSelector(
  getMerchantStatusValue,
  onboardingStatusValue => {
    if (onboardingStatusValue === ONBOARDING_STATUS_VALUES_V2.COMPLETED) {
      return STEP_STATUS.DONE;
    }

    if (onboardingStatusValue < ONBOARDING_STATUS_VALUES_V2.TRANSACTIONS_ENABLED) {
      return STEP_STATUS.DISABLED;
    }

    if (onboardingStatusValue > ONBOARDING_STATUS_VALUES_V2.PAYOUT_DETAILS_STARTED) {
      return STEP_STATUS.PENDING;
    }

    return STEP_STATUS.NOT_STARTED;
  },
);

export const isMerchantTransactionDisabled = createSelector(
  getMerchantStatus,
  onboardingStatus => onboardingStatus === ONBOARDING_STATUS_VALUES_V2.TRANSACTIONS_DISABLED,
);

export const isMerchantSuspended = createSelector(
  getMerchantStatus,
  onboardingStatus => onboardingStatus === ONBOARDING_STATUS_VALUES_V2.SUSPENDED,
);

export const isMerchantTerminated = createSelector(
  getMerchantStatus,
  onboardingStatus => onboardingStatus === ONBOARDING_STATUS_VALUES_V2.TERMINATED,
);

export const isAwaitingPayoutsRequestAfterFirstTransaction = createSelector(
  getMerchantStatusValue,
  hasHadTransaction,
  (merchantStatusValue, hasHadTransaction) =>
    hasHadTransaction &&
    merchantStatusValue >= ONBOARDING_STATUS_VALUES_V2.NOT_STARTED &&
    merchantStatusValue <= ONBOARDING_STATUS_VALUES_V2.TRANSACTIONS_ENABLED,
);
